import utils from '../../utils/utils'

let apiURL = utils.decrypt(document.querySelector("html").getAttribute("api_h5_url"));

if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'https://kane.haiweikexin.com'
}

export default apiURL;